import { useTheme } from 'styled-components';

export default function useSkeletonColors() {
  const theme = useTheme();

  return {
    backgroundColor: theme.defaultColors.skeletonBase,
    foregroundColor: theme.defaultColors.skeletonHighlight,
  };
}
